var scrolledToolbar = 'toolbar_scrolledToolbar__bf6bgv2';
var toolbar = 'toolbar_toolbar__bf6bgv1';
var toolbarWidth = 'var(--toolbar-width__bf6bgv0)';

export { scrolledToolbar, toolbar, toolbarWidth };
//# sourceMappingURL=toolbar.vanilla.mjs.map
